let navbarToggler = document.querySelector('.navbar-toggler');
let navbarDropdown = document.querySelector('#navbarSupportedContent');
let navbarDropdownExpanded = navbarDropdown.getAttribute('aria-expanded');

// Mobile menu toggle

navbarToggler.addEventListener('click', function(){
    navbarDropdown.classList.toggle('show');        
    navbarDropdown.closest(".navbar").classList.toggle('shown');

    if(navbarDropdownExpanded == "true") {
        navbarDropdownExpanded = "false";
    } else {
        navbarDropdownExpanded = "true";
    }

    navbarDropdown.setAttribute("aria-expanded", navbarDropdownExpanded);
});

// Dropdown toggle

function getTogglerId(className, event, fn) {
    let list = document.querySelectorAll(className);
    for (let i = 0, len = list.length; i < len; i++) {
        list[i].addEventListener(event, fn, false);
    }
}

getTogglerId('.dropdown-toggle', 'click', toggleDropdown);

let dropdownMenus = document.querySelectorAll('.dropdown-menu');
let dropdownTogglers = document.querySelectorAll('.dropdown-toggle');

function closeMenus(){
    for (let j = 0; j < dropdownMenus.length; j++) {
        dropdownMenus[j].classList.remove('show');
    }
    for (let k = 0; k < dropdownTogglers.length; k++) {
        dropdownTogglers[k].classList.remove('show');
        dropdownTogglers[k].setAttribute('aria-expanded','false');
        dropdownTogglers[k].closest(".navbar").classList.add('show');
    }
}

function toggleDropdown(e) {
    let isOpen = this.classList.contains('show');

    if (!isOpen) {
        closeMenus();
        document.querySelector(`[aria-labelledby=${this.id}]`).classList.add('show');
        this.classList.add('show');
        this.setAttribute('aria-expanded','true');
    } else if (isOpen) {
        closeMenus();
    }

    e.preventDefault();
}

// Close dropdowns on focusout

let navbar = document.querySelector('.navbar');

navbar.addEventListener('focusout', function() {
    window.onclick = function(event){
        if (document.querySelector('.navbar').contains(event.target)){
            return;
        } else {
            closeMenus();
        }
    };
});

// When scrolled beyond x pixels add a class to the navbar
var lastScrollPosition = 0,
    tick = false,
    mainnav = document.getElementsByClassName('navbar-main')[0];  // Track whether call is currently in process

function customFunction (scrollPos) {
    // Custom function that does something
    // based on the scroll position
    if(scrollPos >= 50) {
        mainnav.classList.add('bg');
    } else {
        mainnav.classList.remove('bg');
    }
}

window.addEventListener('scroll', function(e) {
  lastScrollPosition = window.scrollY;
  if (!tick) {
    setTimeout(function () {
      customFunction(lastScrollPosition);
      tick = false;
    }, 16)
  }
  tick = true;
});